var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"loading-circular",style:({'width': (_vm.cx + _vm.strokeWidth) * 2 + 'px', 'height': (_vm.cy + _vm.strokeWidth) * 2 +
'px'})},[_c('circle',{staticClass:"loading-path",style:({'stroke-dasharray': ((Math.PI * _vm.r / 3) + ", " + (Math.PI * _vm.r / 3))}),attrs:{"cx":_vm.cx,"cy":_vm.cy,"r":_vm.r,"fill":"none","stroke":_vm.stroke,"stroke-width":_vm.strokeWidth}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e87c191e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/new/common/svgLoading.vue
// module id = null
// module chunks = 